import { IMAGE_FORMATS } from '../constants';

export const isSvg = ({ format }) => format === IMAGE_FORMATS.SVG;

export const isJpg = ({ format }) => format === IMAGE_FORMATS.JPG;

export const isPng = ({ format }) => format === IMAGE_FORMATS.PNG;

export const isGif = ({ format }) => format === IMAGE_FORMATS.GIF;
